<h3 class="ui primary header">
  {{ modal.context.data?.operation === "edit" ? "Edit Alert" : "Create Alert" }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content create-alert-form">
  <div
    class="scroll-wrapper ui basic segment"
    [ngClass]="{
      loading:
      channelLoading ||
        usersLoading ||
        notificationPreferencesLoading ||
        scenariosLoading
    }"
  >

  <!-- <div class="preference">
    <sui-checkbox
          class="variable-section-check"
          [ngModel]="checked"
        >
          <span class="pref-text">Email</span>
        </sui-checkbox>
  </div> -->
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div class="ui form" [formGroup]="createAlertForm">
      
      
      <div class="field section" [ngClass]="displayFieldCss('alertScenario')">
        <label class="required">Alert Scenario</label>
        <select
          class="ui fluid dropdown"
          placeholder="Select role"
          type="text"
          formControlName="alertScenario"
        >
          <option
            *ngFor="let alertScenario of alertScenarios"
            [ngValue]="alertScenario.alertScenarioId"
          >
            {{ alertScenario.alertScenarioName }}
          </option>
        </select>
        <!-- <input
          #input
          formControlName="alertScenario"
          type="text"
          placeholder="Enter scenario"
        /> -->
        <app-field-error-display
          [displayError]="isFieldValid('alertScenario')"
          errorMsg="Please enter scenario"
        >
        </app-field-error-display>
      </div>

      <div
        *ngIf="modal.context.data.location == 'all-users'"
        class="field section"
        [ngClass]="displayFieldCss('variableInput')"
      >
        <label class="required variable-section">Variable</label>

        <input
          formControlName="variableInput"
          type="text"
          placeholder="Enter a variable Input"
        />
        <app-field-error-display
          [displayError]="isFieldValid('variableInput')"
          errorMsg="Please enter a variableInput"
        >
        </app-field-error-display>
      </div>
      <div
        *ngIf="modal.context.data.location !== 'all-users'"
        class="field variable-section"
        [ngClass]="displayFieldCss('variableSelected')"
      >
        <label>Select Variable</label>

        <ng-container *ngIf="acceptUserId">
          <select
            class="ui fluid dropdown"
            placeholder="Select role"
            type="text"
            formControlName="variableSelected"
          >
            <option *ngFor="let opt of users" [ngValue]="opt.id">
              {{ opt.name }}
            </option>
          </select>
          <app-field-error-display
            [displayError]="isFieldValid('variableSelected')"
            errorMsg="Please Select a user"
          >
          </app-field-error-display>
        </ng-container>

        <ng-container *ngIf="!acceptUserId">
          <input
            formControlName="variableSelected"
            type="text"
            placeholder="Enter IP Address"
          />
          <app-field-error-display
            [displayError]="isFieldValid('variableSelected')"
            errorMsg="Please enter IP address"
          >
          </app-field-error-display>
        </ng-container>
      </div>

      <div
        class="field variable-section"
        [ngClass]="displayFieldCss('timeframe')"
      >
        <label>Time Frame</label>

        <div class="ui right labeled input">
          <input
            formControlName="timeframe"
            type="text"
            placeholder="Please enter a time frame"
          />
          <div class="ui basic label">seconds</div>
        </div>
        <app-field-error-display
          [displayError]="isFieldValid('timeframe')"
          errorMsg="Please enter a time frame"
        >
        </app-field-error-display>
      </div>

      <div class="field section" [ngClass]="displayFieldCss('minimumCount')">
        <label class="required variable-section">Minimum Count</label>

        <input
          formControlName="minimumCount"
          type="text"
          placeholder="Enter a minimum count"
        />
        <app-field-error-display
          [displayError]="isFieldValid('minimumCount')"
          errorMsg="Please enter a minimum count"
        >
        </app-field-error-display>
      </div>

      <div class="field section" [ngClass]="displayFieldCss('description')">
        <label class="required">Description</label>
        <textarea
          rows="2"
          formControlName="description"
          type="text"
          placeholder="Enter description"
        ></textarea>
        <app-field-error-display
          [displayError]="isFieldValid('description')"
          errorMsg="Please enter description"
        >
        </app-field-error-display>
      </div>

      <div class="field section">
        <label class="required">Notification Preference</label>

        

        <!-- <input
          formControlName="notification"
          type="text"
          placeholder="Enter teller  payer's email"
        />
        <app-field-error-display
          [displayError]="isFieldValid('notification')"
          errorMsg="Please select a notification"
        >
        </app-field-error-display> -->
        <!-- <input
            formControlName="notification"
            type="text"
            placeholder="Enter teller  payer's email"
          />
          <app-field-error-display
            [displayError]="isFieldValid('notification')"
            errorMsg="Please select a notification"
          >
          </app-field-error-display> -->
      </div>

      <!-- <div class="field" [ngClass]="displayFieldCss('enableOnSave')">
          <label class="required">Enable on Save</label>
          <sui-checkbox
            class="toggle enable_on_save"
            formControlName="enableOnSave"
            (checkChange)="
              (createAlertForm.value.enableOnSave == true ? 'save' : 'unsave')
            "
          >
          </sui-checkbox>
        </div> -->
    </div>


    <ng-container *ngIf="modal.context.data?.operation !== 'edit'">
      <div class="preferences" >
        <div class="preference" style="margin-top: 19px" *ngIf="slackPreferences.length">
          <sui-checkbox
            class="variable-section-check"
            (click)="notificationPreferenceClick($event, 'slack')"
          >
            <span class="pref-text">Slack</span>
          </sui-checkbox>
  
          <div class="preference-options" *ngIf="displaySlackPreferences">
            <sui-checkbox
              class="variable-section-check"
              *ngFor="let slackPreference of slackPreferences"
              (click)="
                notificationPreferenceChildClick(
                  'slack',
                  slackPreference?.settingId
                )
              "
            >
              <!-- Display channel names instead of channel IDs -->
              {{ slackPreference?.name }}
            </sui-checkbox>
          </div>
        </div>
  
  
  
        <div class="preference" *ngIf="emailPreferences.length">
          <sui-checkbox
            class="variable-section-check"
            (click)="notificationPreferenceClick($event, 'email')"
          >
            <span class="pref-text">Email</span>
          </sui-checkbox>
          <div class="preference-options" *ngIf="displayEmailPreferences">
            <sui-checkbox
              class="variable-section-check"
              *ngFor="let emailPreference of emailPreferences"
              (click)="
                notificationPreferenceChildClick(
                  'email',
                  emailPreference?.settingId
                )
              "
            >
              {{ emailPreference?.name }}
            </sui-checkbox>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="modal.context.data?.operation === 'edit'">
      <div class="preferences" >
        <div class="preference" style="margin-top: 19px" *ngIf="slackPreferences.length">
          <sui-checkbox
            class="variable-section-check"
            [ngModel]="modal.context.data?.slack?.length"
            (click)="notificationPreferenceClick($event, 'slack')"
          >
            <span class="pref-text">Slack</span>
          </sui-checkbox>
  
          <div class="preference-options" *ngIf="displaySlackPreferences">
            <sui-checkbox
              class="variable-section-check"
              *ngFor="let slackPreference of slackPreferences"
              [ngModel]="slackPreference?.checked"
              (click)="
                notificationPreferenceChildClick(
                  'slack',
                  slackPreference?.settingId
                )
              "
            >
              <!-- Display channel names instead of channel IDs -->
              {{ slackPreference?.name }}
            </sui-checkbox>
          </div>
        </div>
  
  
  
        <div class="preference" *ngIf="emailPreferences.length">
          <sui-checkbox
            class="variable-section-check"
            [ngModel]="modal.context.data?.email?.length"
            (click)="notificationPreferenceClick($event, 'email')"
          >
            <span class="pref-text">Email</span>
          </sui-checkbox>
          <div class="preference-options" *ngIf="displayEmailPreferences">
            <sui-checkbox
              class="variable-section-check"
              *ngFor="let emailPreference of emailPreferences"
              [ngModel]="emailPreference?.checked"
              (click)="
                notificationPreferenceChildClick(
                  'email',
                  emailPreference?.settingId
                )
              "
            >
              {{ emailPreference?.name }}
            </sui-checkbox>
          </div>
        </div>
      </div>
    </ng-container>
    
  </div>
</div>

<div class="actions" style="border: none; background-color: #fff">
  <button class="ui button cancel-modal" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [disabled]="!isFormValid()"
    (click)="save()"
    [ngClass]="{ 'yellow loading': saving }"
    autofocus
  >
    Save
  </button>
</div>
